import React from "react";
import CommonLayout from '../../components/shop/common-layout';
import Container from "reactstrap/lib/Container";
import { useTranslation } from "react-i18next";
import DropShippingServices from "../../services/DropShippingServices";
import PremadeCartForm from "./premade-form";

export async function getServerSideProps(params) {
    const { code } = params.query
    try {
        if (!code) {
            return { props: { preCart: null } }
        }
        const preCart = await DropShippingServices.getByCode(code)

        return { props: { preCart: preCart.data } }
    } catch (error) {
        return { props: { preCart: null } }
    }
}

function PremadeCart({ preCart }) {
    const { t } = useTranslation();
    return (
        <CommonLayout title={t("premade-cart")} parent={t("home")} >
            <Container className="mt-3 mb-3" >
                <div className="checkout-page" style={{ minHeight: '50vh' }}>
                    <PremadeCartForm preCart={preCart} />
                </div>
            </Container>
        </CommonLayout>);
}

export default PremadeCart;
